module.exports = __webpack_public_path__ + "img/drive-panel-heater-off.a6c88f71.svg";